import { Sparkles } from 'lucide-react';

export const PlatinumComingSoon = ({ title, desc }) => (
  <div style={{ minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div
      data-testid="platinum-coming-soon"
      style={{
        maxWidth: 560, textAlign: 'center', padding: '3rem 2.5rem', borderRadius: 20,
        background: '#FFFDD0', border: '1px solid rgba(127,13,108,0.4)',
        boxShadow: '0 12px 40px rgba(92,10,78,0.14)',
      }}
    >
      <Sparkles className="w-9 h-9 mx-auto mb-3" style={{ color: '#7F0D6C' }} />
      <h2 style={{ fontSize: '2rem', fontWeight: 700, color: '#7F0D6C', marginBottom: '.6rem' }}>{title}</h2>
      <p style={{ color: '#4a2340', fontSize: '1.15rem', lineHeight: 1.55, fontStyle: 'italic' }}>{desc}</p>
      <p style={{ color: '#7F0D6C', fontSize: '.95rem', marginTop: '1.5rem', letterSpacing: '.08em', textTransform: 'uppercase' }}>
        Being woven into being — coming soon
      </p>
    </div>
  </div>
);

export default PlatinumComingSoon;
